const isTruthy = (value)=>Boolean(value);

export { isTruthy };
//# sourceMappingURL=isTruthy.mjs.map
